<template>
  <div v-if="$store.state.chatFlag" v-bind:style="{'height':$store.state.screenHeight>800?'620px':`${$store.state.screenHeight-100}px`}" style="width:400px;height:620px;position:fixed;bottom:50px;right:50px;border:1px solid #808080;background-color:#ffffff;border-radius:10px;padding:5px;z-index:9999999;border-bottom-left-radius:0px;border-top-left-radius:0px;">
    <div @click="$store.state.chatFlag=false;isInit=false" class="closeBtn">x</div>
    <div ref="showChatDiv" v-bind:style="{'height':$store.state.screenHeight>800?'430px':`${$store.state.screenHeight-300}px`}" style="height:430px;border:1px solid #808080;border-top-left-radius:10px;border-top-right-radius:10px;overflow-y:auto;background-color:#f5f5f5;">
      <div v-if="historyBtn" @click="getHistoryList(historyFirst,5)" style="text-align:center;color:#009bdb;padding-top:5px;cursor:pointer;">查看更多消息</div>
      <!--历史-->
      <div v-for="(item, i) in historyList" style="padding:10px 20px;">
        <div v-if="item.tag==1" style="text-align:right;">
          <el-image :src="imgUrl+item.avatar" style="width:30px; height:30px;float:right;margin-left:10px;" :fit="'cover'" lazy></el-image>
          <div v-if="item.label==''||item.label=='txt'" class="chatBlack" style="background-color:#9eea6a;">{{item.content}}</div>
          <div v-else-if="item.label=='img'" class="chatBlack" style="background-color:#9eea6a;">
            <el-image :src="imgUrl+item.content" @click="dialogImageUrl=imgUrl+item.content;dialogVisible=true;" style="max-width:100%;"></el-image>
          </div>
          <div v-else-if="item.label=='file'" class="chatBlack" style="background-color:#9eea6a;">
            <a :href="imgUrl+item.content" target="_blank">文件</a>
          </div>
        </div>
        <div v-if="item.tag==2" style="text-align:left;">
          <el-image :src="imgUrl+item.avatar" style="width:30px; height:30px;float:left;margin-right:10px;" :fit="'cover'" lazy></el-image>
          <div v-if="item.label==''||item.label=='txt'" class="chatBlack" style="background-color:#ffffff;">{{item.content}}</div>
          <div v-else-if="item.label=='img'" class="chatBlack" style="background-color:#ffffff;">
            <el-image :src="imgUrl+item.content" @click="dialogImageUrl=imgUrl+item.content;dialogVisible=true;" style="max-width:100%;"></el-image>
          </div>
          <div v-else-if="item.label=='file'" class="chatBlack" style="background-color:#ffffff;">
            <a :href="imgUrl+item.content" target="_blank">文件</a>
          </div>
        </div>
      </div>
      <!--当前-->
      <div v-for="(item, i) in chatList" style="padding:10px 20px;">
        <div v-if="item.tag==1&&!item.hide" style="text-align:right;">
          <el-image :src="imgUrl+item.avatar" style="width:30px; height:30px;float:right;margin-left:10px;" :fit="'cover'" lazy></el-image>
          <i v-if="item.err" class="el-icon-warning" style="color:#ff0000;"></i>
          <div v-if="item.label==''||item.label=='txt'" class="chatBlack" style="background-color:#9eea6a;">{{item.content}}</div>
          <div v-else-if="item.label=='img'" class="chatBlack" style="background-color:#9eea6a;">
            <el-image :src="imgUrl+item.content" @click="dialogImageUrl=imgUrl+item.content;dialogVisible=true;" style="max-width:100%;"></el-image>
          </div>
          <div v-else-if="item.label=='file'" class="chatBlack" style="background-color:#9eea6a;">
            <a :href="imgUrl+item.content" target="_blank">文件</a>
          </div>
        </div>
        <div v-if="item.tag==2" style="text-align:left;">
          <el-image :src="imgUrl+item.avatar" style="width:30px; height:30px;float:left;margin-right:10px;" :fit="'cover'" lazy></el-image>
          <div v-if="item.label==''||item.label=='txt'" class="chatBlack" style="background-color:#ffffff;">{{item.content}}</div>
          <div v-else-if="item.label=='img'" class="chatBlack" style="background-color:#ffffff;">
            <el-image :src="imgUrl+item.content" @click="dialogImageUrl=imgUrl+item.content;dialogVisible=true;" style="max-width:100%;"></el-image>
          </div>
          <div v-else-if="item.label=='file'" class="chatBlack" style="background-color:#ffffff;">
            <a :href="imgUrl+item.content" target="_blank">文件</a>
          </div>
        </div>
      </div>
      <!--进度条-->
      <el-progress :percentage="percentage" v-if="percentage" style="width:120px;position:absolute;bottom:200px;right:280px;"></el-progress>
    </div>
    <div style="padding:5px;text-align:left;">
      <el-button size="mini" @click="sendImgOrFileFun('img');" title="图片" icon="el-icon-picture-outline" circle></el-button>
      <el-button size="mini" @click="sendImgOrFileFun('file')" title="文件" icon="el-icon-folder-add" circle></el-button>
    </div>
    <textarea v-model="str" @keyup.enter="sendFun()" placeholder="聊天内容" style="width:378px;height:70px;border:1px solid #808080;padding:10px;"></textarea>
    <div style="text-align:right;padding-right:30px;padding-top:5px;">
      <el-button @click="sendFun()">发送</el-button>
    </div>
    <div v-html="init()" style="width:0;height:0;overflow:hidden;"></div>
    <input type="file" id="fileInput" ref="fileInput" @change="uploadFun" style="display:none;" />
    <el-dialog :visible.sync="dialogVisible" fullscreen :modal-append-to-body="false">
      <div style="text-align:center;">
        <img :src="dialogImageUrl" style="max-width:100%;max-height:100%;">
      </div>
    </el-dialog>
    <!--列表-->
    <div v-bind:style="{'height':$store.state.screenHeight>800?'630px':`${$store.state.screenHeight-90}px`}" style="position:absolute;width:150px;height:630px;background-color:#ffffff;right:410px;bottom:-1px;border:1px solid #808080;border-radius:10px;overflow-y:auto;border-bottom-right-radius:0px;border-top-right-radius:0px;">
      <div style="height:30px;"></div>
      <div v-for="(item, i) in userList" class="userListClass" v-bind:class="[{active:$store.state.otherid==item.friendId}]" style="border:1px solid #f5f5f5;height:40px;line-height:40px;cursor:pointer;">
        <el-badge :value="item.unreadMessage?item.unreadMessage:''" :max="99" class="item" style="height:30px;margin-top:-15px;">
          <img :src="imgUrl+item.avatar" style="width:30px;height:30px;object-fit:cover;vertical-align:middle;margin-left:3px;">
        </el-badge>
        <span @click="$store.state.otherid=item.friendId" style="display:inline-block;width:70px;padding-left:3px;">{{item.nickName.length>5?item.nickName.substring(0,5)+'...':item.nickName}}</span>
        <i @click="deleteUserFun(item.friendId)" class="el-icon-circle-close" style="float:right;margin-top:15px;margin-right:5px;"></i>
      </div>
      <div style="height:30px;"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'myChat',
    data() {
      return {
        str: '',
        fileStr: '',
        sendType: '',
        sendFlag: false,
        isInit: false,
        historyBtn: true,
        chatInterval: null,
        userInterval: null,
        chatList: [],
        chatListLast: null,
        historyList: [],
        historyFirst: null,
        dialogVisible: false,
        dialogImageUrl: '',
        percentage: 0,
        userList: [],
        api: api,
        imgUrl: imgUrl,
        uploadUrl: uploadUrl,
      }
    },
    props: ['myid', 'otherid'],
    mounted: function () {
      var _this = this;
      _this.ready();
    },
    watch: {
      otherid(val, oldVal) {//普通的watch监听
        //console.log("otherid: " + val, oldVal);
        var _this = this;
        if (val != oldVal) {
          _this.isInit = false;
          _this.init();
        }
      }
    },
    methods: {
      ready: function () {
        var _this = this;
        
      },
      init: function () {
        var _this = this;
        if (!$.cookie('LYPT_token')) {
          _this.$store.state.chatFlag = false;
          _this.isInit = false;
          _this.$alert(`<a href="/" style="cursor:pointer;color:#f27713;">去登录<a>`, '请先登录！', {
            dangerouslyUseHTMLString: true,
            callback: action => {
              _this.$router.push({ name: 'home' });
            }
          });
          return;
        }
        if (!_this.otherid) {
          _this.getUserList();
          return;
        }
        if (_this.isInit) {
          return '';
        }
        _this.isInit = true;
        console.log('do initChat');
        if (!_this.chatInterval) {
          _this.chatInterval = setInterval(_this.getChat, 5000);
        }
        if (!_this.userInterval) {
          _this.userInterval = setInterval(_this.getUserList, 5000);
        }
        _this.chatList = [];
        _this.historyList = [];
        _this.historyFirst = null;
        _this.chatListLast = null;
        _this.getHistoryList();
        return '';
      },
      getUserList: function () {
        var _this = this;
        myAjax('/user/myFriend', {}, true, 'get', _this, function (res) {
          if (res.returnCode == '200') {
            _this.userList = res.data.listFriend;
            _this.$store.state.userInfo.chartNum = res.data.chatMessage;
            if (!_this.otherid && _this.userList.length > 0) {
              _this.$store.state.otherid = _this.userList[0].friendId;
              _this.init();
            } else if (!_this.otherid && _this.userList.length == 0) {
              //结束
              _this.$store.state.chatFlag = false;
              _this.isInit = false;
              _this.$message.error('暂无聊天！');
            }
          }
        });
        myAjax('/user/myUnreadNews', {}, true, 'get', _this, function (res) {
          if (res.returnCode == '200') {
            _this.$store.state.userInfo.messageNum = res.data.messageTotal;
            _this.$store.state.userInfo.chartNum = res.data.chatMessage;
          }
        });
      },
      deleteUserFun: function (id) {
        var _this = this;
        myAjax('/user/chat', JSON.stringify({ friendId: id }), true, 'put', _this, function (res) {
          if (res.returnCode == '200') {
            if (id == _this.$store.state.otherid) {
              _this.$store.state.otherid = _this.userList[1].friendId;
            }
            _this.getUserList();
          }
        });
      },
      getHistoryList: function (time, pageSize) {
        var _this = this;
        _this.historyBtn = false;
        console.log(_this.otherid);
        var params = {
          receiveUserId: _this.otherid,
          createTime: time,
          beginNum: 0,
          pageLineMax: pageSize ? pageSize : 4
        };
        myAjax('/user/historyChatRecord', params, true, 'get', _this, function (res) {
          if (res.returnCode == '200') {
            _this.getUserList();//放在这里可以让头像未读在点击后很快刷新
            myAjax('/user/myUnreadNews', {}, true, 'get', _this, function (res) {
              if (res.returnCode == '200') {
                _this.$store.state.userInfo.messageNum = res.data.messageTotal;
                _this.$store.state.userInfo.chartNum = res.data.chatMessage;
              }
            });
            if (_this.historyList.length == 0) {
              _this.historyList = res.data;
            } else {
              _this.historyList = res.data.concat(_this.historyList);
            }
            if (res.data[0]) {
              _this.historyFirst = res.data[0].createTime;
              _this.chatListLast = res.data[res.data.length - 1].createTime;
            }
            if (res.totalNum <= (pageSize ? pageSize : 1)) {
              _this.historyBtn = false;
            } else {
              _this.historyBtn = true;
            }
          } else if (res.returnCode == '40015') {
            _this.$store.state.chatFlag = false;
            _this.isInit = false;
            _this.$store.state.otherid = '';
            _this.$message.error('不能和自己聊天！');
          }
        });
      },
      getChat: function () {
        var _this = this;
        if (!_this.$store.state.chatFlag) {
          window.clearInterval(_this.chatInterval);
          window.clearInterval(_this.userInterval);
          _this.chatInterval = null;
          _this.userInterval = null;
          _this.isInit = false;
          console.log('chat over');
          return;
        }
        var params = {
          receiveUserId: _this.otherid
        };
        if (_this.chatListLast) {
          params.createTime = _this.chatListLast;
        }
        console.log('getChat');
        myAjax('/user/chatRecord', params, true, 'get', _this, function (res) {
          if (res.returnCode == '200') {
            if (_this.chatList.length == 0) {
              _this.chatList = res.data; 
            } else {
              for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].tag == 2) {
                  _this.chatList.push(res.data[i]);
                }
              }
            }
            if (res.data.length) {
              _this.chatListLast = res.data[res.data.length - 1].createTime;
            }
            
          }
        });
      },
      sendFun: function () {
        var _this = this;
        if (_this.str.length == 0 || (_this.str.length == 1 && _this.str.indexOf('\n') != -1)) {
          _this.str = '';
          return;
        }
        var params = {
          receiveUserId: _this.otherid,
          content: _this.str,
          label: 'txt'
        };
        let chatItemId = new Date().getTime();
        var temp = {
          tag: 1,
          avatar: $.cookie('LYPT_avatar'),
          nickName: $.cookie('LYPT_nickname'),
          content: _this.str,
          createTime: _this.getFullDate(new Date().getTime()),
          label: 'txt',
          id: chatItemId,
          err: false,
        };
        _this.chatList.push(temp);
        _this.str = '';
        setTimeout(function () { _this.$refs.showChatDiv.scrollTop = 9999999; }, 10);
        myAjax('/user/chatRecord', JSON.stringify(params), true, 'post', _this, function (res) {//JSON.stringify(params)
          if (res.returnCode == '200') {
            _this.getUserList();
          } else {
            for (var i = 0; i < _this.chatList.length; i++) {
              if (_this.chatList[i].id == chatItemId) {
                _this.chatList[i].err = true;
              }
            }
          }
        });
      },
      sendImgOrFileFun: function (type) {
        var _this = this;
        _this.sendType = type;
        _this.$refs.fileInput.click();
      },
      uploadFun: function () {
        var _this = this;
        if (_this.sendType == 'img' &&!_this.beforeImgUpload(_this.$refs.fileInput.files[0])) {
          _this.$refs.fileInput.value = '';
          return;
        }
        if (_this.sendFlag) {
          return;
        }
        _this.sendFlag = true;
        var formFile = new FormData();
        formFile.append("file", _this.$refs.fileInput.files[0]);
        formFile.append("filePath", 'images/');
        formFile.append("index", 1);
        $.ajax({
          url: _this.uploadUrl,
          type: "POST",
          data: formFile,
          cache: false,
          contentType: false,
          processData: false,
          xhr: function () {
            var xhr = new XMLHttpRequest();
            xhr.upload.addEventListener('progress', function (e) {
              _this.percentage = ((e.loaded / e.total) * 100).toFixed(1)*1;
            })
            return xhr;
          },
          success: function (res) {
            if (res.returnCode == '200') {
              _this.fileStr = res.data.filePath;
              _this.percentage = 0;
              var params = {
                receiveUserId: _this.otherid,
                content: _this.fileStr,
                label: _this.sendType
              };
              myAjax('/user/chatRecord', JSON.stringify(params), true, 'post', _this, function (res) {
                if (res.returnCode == '200') {
                  var temp = {
                    tag: 1,
                    avatar: $.cookie('LYPT_avatar'),
                    nickName: $.cookie('LYPT_nickname'),
                    content: _this.fileStr,
                    createTime: _this.getFullDate(new Date().getTime()),
                    label: _this.sendType
                  };
                  _this.chatList.push(temp);
                  _this.sendFlag = false;
                  setTimeout(function () { _this.$refs.showChatDiv.scrollTop = 9999999; }, 10);
                }
              });
            } else {
              _this.$alert('上传失败', '提示');
            }
            _this.$refs.fileInput.value = '';
            _this.percentage = 0;
          },
          error: function (err) {
            console.log(err);
            _this.$refs.fileInput.value = '';
            _this.percentage = 0;
            _this.$alert('上传失败', '提示');
          }
        });
      },
      beforeImgUpload(file) {
        const isImg = isImgType(file.type);
        const isLt = file.size / 1024 / 1024 < 2;

        if (!isImg) {
          this.$message.error('上传图片只能是 jpg/png/gif 格式!');
          return false;
        }
        if (!isLt) {
          this.$message.error('上传图片大小不能超过 2MB!');
          return false;
        }
        return isImg && isLt;
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .closeBtn {
    width: 20px;
    height: 20px;
    text-align:center;
    line-height: 20px;
    font-size: 16px;
    color: #ff0000;
    margin-top: -15px;
    margin-left: 390px;
    border: 1px solid #ff0000;
    border-radius: 10px;
    background-color: #ffffff;
    cursor: pointer;
  }
  textarea {
    outline: none;
    resize: none;
  }
  .chatBlack {
    display: inline-block;
    line-height: 20px;
    padding: 5px 10px;
    max-width: 220px;
    word-break: break-all;
  }
  .userListClass:hover{
    color:#ff6a00;
  }
  .userListClass.active {
    color: #ff6a00;
  }
</style>



// WEBPACK FOOTER //
// src/modules/myChat.vue